// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_candidates_page{
  background:#fff;
  padding:22px;
  border-radius:20px;
  border:1px solid #edf2f7;
  box-shadow:0 6px 20px rgba(15,23,42,.05);
}

.e2e_candidates_top{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:24px;
}

.e2e_candidates_top h2{
  margin:0;
  font-size:24px;
  font-weight:800;
  color:#0f172a;
}

.e2e_candidates_heading_line{
  width:90px;
  height:4px;
  margin-top:10px;
  border-radius:20px;
  background:linear-gradient(90deg,#2563eb,#7c3aed);
}

.e2e_candidates_add_btn{
  border:none;
  height:42px;
  padding:0 22px;
  border-radius:12px;
  color:#fff;
  cursor:pointer;
  font-weight:700;
  background:linear-gradient(135deg,#1677ff,#2563eb);
}

.e2e_candidates_filters{
  display:flex;
  justify-content:space-between;
  align-items:center;
  background:#f8fafc;
  border:1px solid #edf2f7;
  padding:18px;
  border-radius:16px;
  margin-bottom:18px;
}

.e2e_candidates_filter_left{
  display:flex;
  align-items:center;
  gap:12px;
}

.e2e_candidates_select{
  height:40px;
  min-width:180px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:0 12px;
}

.e2e_candidates_report_btn{
  height:40px;
  border:none;
  padding:0 18px;
  border-radius:10px;
  color:white;
  font-weight:700;
  cursor:pointer;
  background:linear-gradient(135deg,#06b6d4,#0891b2);
}

.e2e_candidates_search{
  width:260px;
  height:40px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:0 14px;
}

.e2e_candidates_show_row{
  margin-bottom:15px;
  color:#475569;
}

.e2e_candidates_entries{
  height:36px;
  margin:0 10px;
  border:1px solid #dbe2ea;
  border-radius:8px;
}

.e2e_candidates_table_wrapper{
  overflow-x:auto;
}

.e2e_candidates_table{
  width:100%;
  border-collapse:separate;
  border-spacing:0 10px;
}

.e2e_candidates_head_row th{
  background:#f8fafc;
  padding:15px;
  font-size:12px;
  text-transform:uppercase;
  color:#64748b;
  border-top:1px solid #e2e8f0;
  border-bottom:1px solid #e2e8f0;
}

.e2e_candidates_row{
  background:white;
  box-shadow:0 3px 12px rgba(15,23,42,.05);
}

.e2e_candidates_row:hover{
  transform:translateY(-2px);
  transition:.3s;
}

.e2e_candidates_row td{
  padding:18px 16px;
  border-top:1px solid #f1f5f9;
  border-bottom:1px solid #f1f5f9;
  text-align:center;
  vertical-align:middle;
}

.e2e_candidates_th_id,
.e2e_candidates_td_id{
  width:60px;
}

.e2e_candidates_th_date,
.e2e_candidates_td_date{
  width:18%;
}

.e2e_candidates_th_requirement,
.e2e_candidates_td_requirement{
  width:40%;
  text-align:center;
}

.e2e_candidates_th_client,
.e2e_candidates_td_client{
  width:20%;
}

.e2e_candidates_th_action,
.e2e_candidates_td_action{
  width:220px;
}

.e2e_candidates_details{
  display:flex;
  flex-direction:column;
  gap:6px;
}

.e2e_candidates_details p{
  margin:0;
  color:#475569;
}

.e2e_candidates_details strong{
  color:#0f172a;
  margin-left:5px;
}

.e2e_candidates_actions{
  display:flex;
  justify-content:center;
  gap:8px;
}

.e2e_candidates_view_btn,
.e2e_candidates_edit_btn,
.e2e_candidates_delete_btn{
  border:none;
  min-width:65px;
  height:32px;
  border-radius:8px;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}

.e2e_candidates_view_btn{
  background:#dbeafe;
  color:#2563eb;
}

.e2e_candidates_edit_btn{
  background:#fef3c7;
  color:#d97706;
}

.e2e_candidates_delete_btn{
  background:#fee2e2;
  color:#dc2626;
}

@media(max-width:992px){

  .e2e_candidates_filters{
    flex-direction:column;
    align-items:stretch;
  }

  .e2e_candidates_search{
    width:100%;
  }

  .e2e_candidates_table{
    min-width:900px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/candidates.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,OAAO;AACT;;AAEA;;;EAGE,WAAW;EACX,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".e2e_candidates_page{\r\n  background:#fff;\r\n  padding:22px;\r\n  border-radius:20px;\r\n  border:1px solid #edf2f7;\r\n  box-shadow:0 6px 20px rgba(15,23,42,.05);\r\n}\r\n\r\n.e2e_candidates_top{\r\n  display:flex;\r\n  justify-content:space-between;\r\n  align-items:center;\r\n  margin-bottom:24px;\r\n}\r\n\r\n.e2e_candidates_top h2{\r\n  margin:0;\r\n  font-size:24px;\r\n  font-weight:800;\r\n  color:#0f172a;\r\n}\r\n\r\n.e2e_candidates_heading_line{\r\n  width:90px;\r\n  height:4px;\r\n  margin-top:10px;\r\n  border-radius:20px;\r\n  background:linear-gradient(90deg,#2563eb,#7c3aed);\r\n}\r\n\r\n.e2e_candidates_add_btn{\r\n  border:none;\r\n  height:42px;\r\n  padding:0 22px;\r\n  border-radius:12px;\r\n  color:#fff;\r\n  cursor:pointer;\r\n  font-weight:700;\r\n  background:linear-gradient(135deg,#1677ff,#2563eb);\r\n}\r\n\r\n.e2e_candidates_filters{\r\n  display:flex;\r\n  justify-content:space-between;\r\n  align-items:center;\r\n  background:#f8fafc;\r\n  border:1px solid #edf2f7;\r\n  padding:18px;\r\n  border-radius:16px;\r\n  margin-bottom:18px;\r\n}\r\n\r\n.e2e_candidates_filter_left{\r\n  display:flex;\r\n  align-items:center;\r\n  gap:12px;\r\n}\r\n\r\n.e2e_candidates_select{\r\n  height:40px;\r\n  min-width:180px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:10px;\r\n  padding:0 12px;\r\n}\r\n\r\n.e2e_candidates_report_btn{\r\n  height:40px;\r\n  border:none;\r\n  padding:0 18px;\r\n  border-radius:10px;\r\n  color:white;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n  background:linear-gradient(135deg,#06b6d4,#0891b2);\r\n}\r\n\r\n.e2e_candidates_search{\r\n  width:260px;\r\n  height:40px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:10px;\r\n  padding:0 14px;\r\n}\r\n\r\n.e2e_candidates_show_row{\r\n  margin-bottom:15px;\r\n  color:#475569;\r\n}\r\n\r\n.e2e_candidates_entries{\r\n  height:36px;\r\n  margin:0 10px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:8px;\r\n}\r\n\r\n.e2e_candidates_table_wrapper{\r\n  overflow-x:auto;\r\n}\r\n\r\n.e2e_candidates_table{\r\n  width:100%;\r\n  border-collapse:separate;\r\n  border-spacing:0 10px;\r\n}\r\n\r\n.e2e_candidates_head_row th{\r\n  background:#f8fafc;\r\n  padding:15px;\r\n  font-size:12px;\r\n  text-transform:uppercase;\r\n  color:#64748b;\r\n  border-top:1px solid #e2e8f0;\r\n  border-bottom:1px solid #e2e8f0;\r\n}\r\n\r\n.e2e_candidates_row{\r\n  background:white;\r\n  box-shadow:0 3px 12px rgba(15,23,42,.05);\r\n}\r\n\r\n.e2e_candidates_row:hover{\r\n  transform:translateY(-2px);\r\n  transition:.3s;\r\n}\r\n\r\n.e2e_candidates_row td{\r\n  padding:18px 16px;\r\n  border-top:1px solid #f1f5f9;\r\n  border-bottom:1px solid #f1f5f9;\r\n  text-align:center;\r\n  vertical-align:middle;\r\n}\r\n\r\n.e2e_candidates_th_id,\r\n.e2e_candidates_td_id{\r\n  width:60px;\r\n}\r\n\r\n.e2e_candidates_th_date,\r\n.e2e_candidates_td_date{\r\n  width:18%;\r\n}\r\n\r\n.e2e_candidates_th_requirement,\r\n.e2e_candidates_td_requirement{\r\n  width:40%;\r\n  text-align:center;\r\n}\r\n\r\n.e2e_candidates_th_client,\r\n.e2e_candidates_td_client{\r\n  width:20%;\r\n}\r\n\r\n.e2e_candidates_th_action,\r\n.e2e_candidates_td_action{\r\n  width:220px;\r\n}\r\n\r\n.e2e_candidates_details{\r\n  display:flex;\r\n  flex-direction:column;\r\n  gap:6px;\r\n}\r\n\r\n.e2e_candidates_details p{\r\n  margin:0;\r\n  color:#475569;\r\n}\r\n\r\n.e2e_candidates_details strong{\r\n  color:#0f172a;\r\n  margin-left:5px;\r\n}\r\n\r\n.e2e_candidates_actions{\r\n  display:flex;\r\n  justify-content:center;\r\n  gap:8px;\r\n}\r\n\r\n.e2e_candidates_view_btn,\r\n.e2e_candidates_edit_btn,\r\n.e2e_candidates_delete_btn{\r\n  border:none;\r\n  min-width:65px;\r\n  height:32px;\r\n  border-radius:8px;\r\n  font-size:11px;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n}\r\n\r\n.e2e_candidates_view_btn{\r\n  background:#dbeafe;\r\n  color:#2563eb;\r\n}\r\n\r\n.e2e_candidates_edit_btn{\r\n  background:#fef3c7;\r\n  color:#d97706;\r\n}\r\n\r\n.e2e_candidates_delete_btn{\r\n  background:#fee2e2;\r\n  color:#dc2626;\r\n}\r\n\r\n@media(max-width:992px){\r\n\r\n  .e2e_candidates_filters{\r\n    flex-direction:column;\r\n    align-items:stretch;\r\n  }\r\n\r\n  .e2e_candidates_search{\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_candidates_table{\r\n    min-width:900px;\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
